import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfb14f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row" }
const _hoisted_2 = {
  key: 1,
  class: "flex-shrink-0 d-flex align-items-center justify-content-between header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "ml-4 my-0",
  href: "#",
  style: {"color":"#8a2a2a","font-family":"Urbanist,sans-serif","font-weight":"800"}
}, "antara", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "breadcrumbs",
  class: "d-flex align-items-center"
}, null, -1))
const _hoisted_6 = { class: "d-flex flex-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "topmenu-buttons",
  class: "ml-auto"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_9 = ["alt", "src"]
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createBlock(_component_Menubar, {
    class: _normalizeClass(["w-100 navbar-light d-flex flex-row align-items-center bg-white", { 'card': !_ctx.breakpointUtil.isOnMobile, 'topmenu': !_ctx.breakpointUtil.isOnMobile }]),
    model: _ctx.menuItems,
    style: {
      'background-size': 'contain',
      'background-position': 'left',
      'background-repeat': 'no-repeat'
      }
  }, {
    start: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.breakpointUtil.isOnMobile && _ctx.$route.path !== '/' && _ctx.$route.path !== '' && !_ctx.$route.path?.startsWith('/wizard'))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "p-button-text flat",
              icon: "pi pi-bars",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.globalState.sidebarVisible = !_ctx.globalState.sidebarVisible), ["stop","prevent"]))
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
        _hoisted_5
      ])
    ]),
    end: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.rpcClient.fullyLoggedIn || _ctx.rpcClient.needsTwoFactorConfirm)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "w-100 p-button-text flat",
              onClick: _ctx.confirmLogout
            }, {
              default: _withCtx(() => [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Ausloggen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.rpcClient.fullyLoggedIn && !_ctx.rpcClient.needsTwoFactorConfirm)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "w-100 p-button-text flat",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/registrierung')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Registrieren")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.rpcClient.fullyLoggedIn && !_ctx.rpcClient.needsTwoFactorConfirm)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "w-100 p-button-text flat",
              onClick: _ctx.goToLogin
            }, {
              default: _withCtx(() => [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Einloggen")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.locale,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_ctx.locale) = $event)),
            _ctx.updateTranslations
          ],
          options: _ctx.countries,
          "option-label": "name"
        }, {
          value: _withCtx((slotProps) => [
            (slotProps.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("img", {
                    alt: slotProps.value.label,
                    src: slotProps.value.icon,
                    class: _normalizeClass(`mr-2 flag flag-${slotProps.value.code.toLowerCase()}`),
                    style: {"width":"18px"}
                  }, null, 10, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slotProps.placeholder), 1))
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["class", "model"]))
}